import React, { useEffect, useState } from 'react';
import '../../../../Assets/Css/EmployeeProjectOverview.scss';
import { Spinner } from 'react-bootstrap';
import { PieChart } from '@mui/x-charts/PieChart';
import { Bar } from 'react-chartjs-2';
import TaskDetailIcon from '../../../../Assets/Images/Employee/task-detail.svg';
import TaskListIcon from '../../../../Assets/Images/Employee/task-list.svg';
import HoursLoggedIcon from '../../../../Assets/Images/Employee/HoursLogged.svg';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useLocation, useParams } from 'react-router-dom';
import { getTasks } from '../../../../Services/Task/action';
import { connect } from 'react-redux';
import { getprojects } from '../../../../Services/Project/action';
import moment from 'moment';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const EmpProjectOverview = ({
  loading,
  getTasks,
  task,
  project,
  getprojects
}) => {
  const location = useLocation();
  const [projectData, setProjectData] = useState({});
  const { projectId } = useParams();
  const fetchData = async () => {
    await getTasks();
    await getprojects();
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (location?.state?.data?.allData) {
      setProjectData(location?.state?.data?.allData);
    }
    else {
      if (project && project?.length > 0 && projectId) {
        const matchedProject = project.find(proj => proj.id == projectId || proj.id == projectId);
        if (matchedProject) {
          setProjectData(matchedProject);
        }
      }
    }
  }, [project, location]);


  const filteredTasks = task?.filter((item) => item?.project_id == projectData?.id);

  const statusCount = filteredTasks?.reduce((acc, curr) => {
    const status = curr?.status;
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const getWeeklyWorkBreakStats = () => {
    const weekStart = moment().startOf('isoWeek').add(1, 'day');
    const weekEnd = moment().endOf('isoWeek').add(1, 'day');

    const workDurations = Array(7).fill(0);
    const breakDurations = Array(7).fill(0);

    filteredTasks?.forEach(taskItem => {
      taskItem?.taskTimerMap?.forEach(timer => {
        const start = moment(timer?.start_time);
        const stop = moment(timer?.stop_time);

        const withinWeek =
          (stop.isValid() && stop.isBetween(weekStart, weekEnd, null, '[]')) ||
          (start.isValid() && start.isBetween(weekStart, weekEnd, null, '[]'));

        if (!withinWeek) return;

        const dayIndex = start.isoWeekday() - 1;
        if (timer?.duration) {
          const match = timer.duration.match(/(\d+)h\s*(\d+)m\s*(\d+)s/);
          if (match) {
            const [, h, m, s] = match.map(Number);
            workDurations[dayIndex] += h * 3600 + m * 60 + s;
          }
        }

        let currentPauseStart = null;
        let actions = [];
        try {
          const history = timer?.action_history;

          actions = typeof history === 'string' ? JSON.parse(history) : (history || []);
        } catch (error) {
          console.error("Failed to parse action_history:", error);
          actions = [];
        }

        let parsedActions = [];
        if (typeof actions === 'string') {
          try {
            parsedActions = JSON.parse(actions);
          } catch (err) {
            console.error("Failed to parse actions string:", err);
            parsedActions = [];
          }
        } else {
          parsedActions = Array.isArray(actions) ? actions : [];
        }

        parsedActions
          ?.sort((a, b) => moment(a.time).diff(moment(b.time)))
          ?.forEach(action => {
            const actionTime = moment(action.time);
            if (!actionTime.isValid() || !actionTime.isBetween(weekStart, weekEnd, null, '[]')) return;

            const dayIdx = actionTime.isoWeekday() - 1;

            if (action.action === 'pause') {
              currentPauseStart = actionTime;
            }

            if (currentPauseStart && (action.action === 'resume' || action.action === 'stop')) {
              const duration = moment.duration(actionTime.diff(currentPauseStart)).asSeconds();
              breakDurations[dayIdx] += duration;
              currentPauseStart = null;
            }
          });
      });
    });

    return {
      workDurations: workDurations.map(sec => (sec / 3600).toFixed(2)),
      breakDurations: breakDurations.map(sec => (sec / 3600).toFixed(2)),
      rawTotals: {
        work: workDurations.reduce((a, b) => a + b, 0) / 3600,
        break: breakDurations.reduce((a, b) => a + b, 0) / 3600,
      }
    };
  };

  const { workDurations, breakDurations, rawTotals } = getWeeklyWorkBreakStats();

  const data = {
    labels: ['Planned', 'Actual'],
    datasets: [
      {
        label: 'Value',
        data: [0, rawTotals.work],
        backgroundColor: ['#679C0D', '#D21010'],
        borderWidth: 1,
        barThickness: 10,
        maxBarThickness: 10,
        borderRadius: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Planned Vs Actual',
      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        formatter: (value) => `${value}`,
        color: 'black',
        font: {
          weight: 'bold',
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
        },
        beginAtZero: true,
        ticks: {
          stepSize: 5,
        },
        grid: {
          display: true,
          color: 'rgba(200, 200, 200, 0.2)',
        },
      },
    },
  };

  return (
    <>
      {loading ? (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          </div>
        </>
      ) : (
        <div className="employeeProject-main">
          <div className="main-division">
            <div className="row">
              <div className="col-lg-12">
                <div className="right-parts">
                  <div className="sub-row">
                    <div className="project-detail-part">
                      <h6 className="project-detail-heading">Project Details</h6>
                      <img src={TaskDetailIcon} className="employee-icon" alt="Task Details" />
                    </div>
                    <div className="row">
                      <h6 className="project-name-label">{[projectData?.name]}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="left-parts">
                  <div className="sub-row">
                    <div className="project-detail-part">
                      <h6 className="project-detail-heading">Task</h6>
                      <img src={TaskListIcon} className="employee-icon" alt="Task Details" />
                    </div>
                    <div className="d-flex justify-content-center">
                      <PieChart
                        className='project-pie-chart'
                        series={[
                          {
                            data: Object.entries(statusCount)?.map(([status, count]) => {
                              return {
                                value: count,
                                label: status,
                                color:
                                  status === 'Incomplete' ? '#D21010' :
                                    status === 'To-Do' ? '#F5C308' :
                                      status === 'Doing' ? '#00B5FF' :
                                        status === 'Completed' ? '#679C0D' :
                                          status === 'Approved' ? '#007900' :
                                            ''
                              };
                            })
                          },
                        ]}
                        width={400}
                        height={200}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3">
                <div className="right-parts">
                  <div className="sub-row">
                    <div className="project-detail-part">
                      <h6 className="project-detail-heading">Hours Logged</h6>
                      <img src={HoursLoggedIcon} className="employee-icon" alt="Task Details" />
                    </div>
                    <Bar data={data} options={options} />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.taskReducer.loading,
    task: state.taskReducer.task,
    project: state.projectReducer.project
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getTasks: () => {
      dispatch(getTasks());
    },
    getprojects: () => {
      dispatch(getprojects());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectOverview);